import { render, staticRenderFns } from "./releasedtoday.vue?vue&type=template&id=20a41a66&scoped=true&"
import script from "./releasedtoday.vue?vue&type=script&lang=js&"
export * from "./releasedtoday.vue?vue&type=script&lang=js&"
import style0 from "./releasedtoday.vue?vue&type=style&index=0&id=20a41a66&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a41a66",
  null
  
)

export default component.exports